import React, { Component } from 'react';

class Pane extends Component {

  propTypes: {
    label: string,
    children: element
  }
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default Pane